// extracted by mini-css-extract-plugin
export default {"card":"userdocuments_card__TGeba","main":"userdocuments_main__nd3rl"};